angular.module('impactx.productview').controller('ProductViewTendersCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ProductViewService',
    'BackService',
    'ToolbarService',
    ProductViewTendersCtrl
]);

function ProductViewTendersCtrl($scope, dataGen, $routeParams, ProductViewService, BackService, ToolbarService) {
    var self = this;
    $scope.url = "tender";

    dataGen.getData($scope, {id: $routeParams.id}, "/productview/list/tenders").then(function () {
        $scope.dynamicItems = new DynamicItems();
        defineButtons();
    });

    self.removeItem = function (tender) {
        ProductViewService.removeTendersFromProductView($routeParams.id, [tender.id]).then(function () {
            $scope.data.relatedTenders.splice($scope.data.relatedTenders.indexOf(tender), 1);
        });
    };

    self.removeAllItems = function () {
        var tenderIds = [];
        angular.forEach($scope.data.relatedTenders, function (tender) {
            tenderIds.push(tender.id);
        });

        return ProductViewService.removeTendersFromProductView($routeParams.id, tenderIds).then(function () {
            BackService.back();
        });
    };

    var DynamicItems = function () {
    };

    DynamicItems.prototype.getItemAtIndex = function (index) {
        if ($scope.data) {
            return $scope.data.relatedTenders[index]
        }
        else {
            return null;
        }
    };

    DynamicItems.prototype.getLength = function () {
        if ($scope.data && $scope.data.relatedTenders) {
            return $scope.data.relatedTenders.length;
        }
        else {
            return 0;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.removeAll,
                action: self.removeAllItems,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}